import {
  fetchLoginAsync,
  fetchRegisterAsync,
  InputRegister,
  RefreshTokenAsync,
} from "@/typescript/Services/Api/AuthApi";
import Config from "./Config";
import { ColorEnum } from "./SuperEnum";
import Tools from "./Tools";
import { useSystemConfigStore } from "@/store/SystemConfigStore";
import type App from "@/App.vue";
import { useUserStore } from "@/store/UserStore";
import { useLocale } from "@/hooks/useLocale";

export default class Global {
  private static _jwtToken = "";
  private static _refreshToken = ""; //刷新Token
  public static app: any; //InstanceType<typeof App>;

  /**
   * 刷新Token
   */
  public static get RefreshToken(): string {
    if (Tools.IsNull(this._refreshToken)) {
      let token = localStorage.getItem("EXCHANGE-REFRESH-TOKEN") ?? "";
      this._refreshToken = token;
    }
    return this._refreshToken;
  }
  /**
   * 设置刷新Token
   */
  public static set RefreshToken(v: string) {
    localStorage.setItem("EXCHANGE-REFRESH-TOKEN", v);
    this._refreshToken = v;
  }

  /**
   * JwtToken
   */
  public static get JwtToken(): string {
    if (Tools.IsNull(this._jwtToken)) {
      let token = localStorage.getItem("EXCHANGE-JWT-TOKEN") ?? "";
      this._jwtToken = token;
    }
    return this._jwtToken;
  }

  /**
   * JwtToken
   */
  public static set JwtToken(v: string) {
    localStorage.setItem("EXCHANGE-JWT-TOKEN", v);
    this._jwtToken = v;
  }

  /**
   * 执行刷新Token
   */
  public static async RefreshTokenAsync(): Promise<boolean> {
    const resp = await RefreshTokenAsync();
    if (resp.CheckIsOk(false)) {
      const d = resp.data!;
      this.JwtToken = d.token;
      this.RefreshToken = d.refreshToken;
      return true;
    }
    return false;
  }

  /**
   * 注册用户
   */
  public static async RegisterAsync(registerObj: InputRegister) {
    const local = useLocale();
    const resp = await fetchRegisterAsync(registerObj);
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(local.t("components.LoginComponent.zccg"));
      const d = resp.data!;
      this.JwtToken = d.token;
      this.RefreshToken = d.refreshToken;
      return true;
    }
    return false;
  }

  /**
   * 尝试登录
   */
  public static async TryToLoginAsync() {
    //检查Token是否过期
    if (Global.JWTTokenEffective()) return true;
    //检查是否存在刷新Token
    if (Tools.IsNotNull(this.RefreshToken)) {
      //执行刷新登录
      if (await this.RefreshTokenAsync()) return true;
    }
    return false;
  }

  /**
   * 执行登录
   * @returns
   */
  public static async ToLoginAsync(input: {
    userName: string;
    password: string;
  }) {
    const resp = await fetchLoginAsync(input);
    if (resp.CheckIsOk()) {
      const d = resp.data!;
      this.JwtToken = d.token;
      this.RefreshToken = d.refreshToken;
      return true;
    }
    return false;
  }

  /**
   * 退出登录
   * @returns
   */
  public static ToLogout() {
    const userStore = useUserStore();
    this.ShowLogin();
    return userStore.ToLogout();
  }

  /**
   * 获取资源URL地址
   * @param url
   */
  public static GetResourceURL(url: string | null | undefined): string {
    const systemConfigStore = useSystemConfigStore();
    if (Tools.IsNull(url)) return "";
    if (url!.startsWith("http")) return url!;
    if (url!.startsWith("/")) url = url!.substring(1);
    return `${systemConfigStore.getConfig!.RESOURCE_HOST}${url!}`;
  }

  /**
   * 检查JWT是否有效
   */
  public static JWTTokenEffective() {
    try {
      let jwtToken = this.JwtToken;
      if (Tools.IsNull(jwtToken)) return false;
      let { header, payload, signature } = Tools.ParseJWT(jwtToken);
      let now = Tools.GetNowTime / 1000;
      let loginExp = payload.exp - 10; //减去10秒
      if (loginExp <= now) return false;
      return true;
    } catch (ex) {
      let errorMessage = "出错了!";
      if (typeof ex == "object") {
        if (ex instanceof Error) {
          errorMessage = ex?.message ?? "未知";
        } else if (typeof ex == "string") {
          errorMessage = ex;
        }
      }
      Tools.ShowLog("JWTTokenEffective", errorMessage, ColorEnum.Error);
    }
  }

  /**
   * 获取API的头部路径
   * @param action
   */
  public static GetAPIUrl(action: string) {
    return `${Config.WEB_API_HOST}${action}`;
  }

  /**
   * 显示登录
   */
  public static ShowLogin() {
    const _ShowLogin = this.app.exposed.ShowLogin;
    _ShowLogin && _ShowLogin();
  }

  /**
   * 显示重置密码
   */
  public static ShowRetPassword() {
    const _ShowRetPassword = this.app.exposed.ShowResetPassword;
    _ShowRetPassword && _ShowRetPassword();
  }
}
